<script>
    import ProgressBar from 'views/components/progressBar/ProgressBar.svelte'
    import ContentLabel from 'views/components/contentLabel/ContentLabel.svelte'
    import Icon from 'views/components/icon/Icon.svelte'
    import ExemptionLabel from 'views/components/exemptionLabel/ExemptionLabel.svelte';

    export let model

    const progress = model.get('progress')
    const hasProgress = _.isFinite(progress)
    const progressPercentage = hasProgress && Math.round(progress * 100) + '%'
    const showLinkToProgress = ACL.isAllowed(ACL.resources.PROGRESS, ACL.actions.VIEW)

    const hasExemption = model.get('hasExemption')
</script>

<div class="slot">
    <a href="/sections/show/{model.id}" class="content">
        <ContentLabel {model}></ContentLabel>
        {#if hasExemption}
            <ExemptionLabel></ExemptionLabel>
        {/if}
    </a>

    {#if hasProgress}
        <div class="navigation">
            {#if showLinkToProgress}
                <a href="/sections/progress/{model.id}" class="button">
                    <Icon name="progress"></Icon>
                    <span>{window.i18n.gettext('Progress')}</span>
                    <strong>{progressPercentage}</strong>
                </a>
            {:else}
                <div class="button locked">
                    <div class="progress-bar">
                        <ProgressBar fragments={{ blue: progress }}></ProgressBar>
                    </div>
                    <strong>{progressPercentage}</strong><span>{window.i18n.gettext('made')}</span>
                </div>
            {/if}
        </div>
    {/if}
</div>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.slot {
  box-shadow: 0 10px 30px 0 rgba(18, 45, 64, 0.12);
  margin-bottom: 12px;
  background: #fff;
  border-radius: 12px;
}
.slot .content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  overflow: hidden;
  text-decoration: none;
  padding: 16px;
}
.slot .content:hover :global([component=content-label__name]) {
  color: hsl(205, 60%, 44%);
}
.slot .navigation {
  display: flex;
  border-top: 1px solid hsl(27, 15%, 93%);
  white-space: nowrap;
  overflow-x: hidden;
}
.slot .navigation .button {
  user-select: none;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-right: 1px solid hsl(27, 15%, 93%);
  color: rgba(18, 45, 64, 0.8);
  fill: currentColor;
  text-decoration: none;
  transition: color 0.35s cubic-bezier(0.455, 0.03, 0.515, 0.955), background 0.35s cubic-bezier(0.455, 0.03, 0.515, 0.955);
}
.slot .navigation .button:first-child {
  border-bottom-left-radius: 12px;
}
.slot .navigation .button:not(.locked):hover {
  cursor: pointer;
  color: #000;
  background: hsl(40, 20%, 96%);
}
.slot .navigation .button span {
  margin-left: 4px;
}
@media (max-width: 620px) {
  .slot .navigation .button span {
    display: none;
  }
}
.slot .navigation .button strong {
  margin-left: 4px;
  font-weight: 400;
  color: #122d40;
}
.slot .navigation .button :global(svg) {
  width: 16px;
  height: 16px;
}
.slot .navigation .button .progress-bar {
  margin-left: 4px;
  margin-right: 16px;
  width: 200px;
}
@media (max-width: 620px) {
  .slot .navigation .button .progress-bar {
    width: 100px;
  }
}</style>
